import React, {useEffect, useState} from "react";
import Modal from "../../../component/Global/Modal";
import ReusableDiv from "src/support/ReusableDiv";
import {useUserStore} from "../../../hooks/admin/user";
import {useAdminCommonStore} from "src/hooks/admin/adminCommon";
import AlertContentWithFlag from "../../Checkout/AlertContentWithFlag";

const RoleSelection = (props) => {
  const [roles, setRoles] = useState([]);
  const [{orgList, roleList, roleListMessage}, {get_organization_detail, get_role_list}, {}] = useAdminCommonStore();
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [
    {
      userAcctList,
      roleSelectionPopUpStatus,
      selectedRoles,
      selectedRoleIndex,
      selectedUserSponsorAccounts,
    },
    {},
    {
      update_user_acct_sponsorship,
      set_role_selection_popup_status,
      set_selected_roles,
      set_user_acct_list,
      set_selected_role_index
    },
  ] = useUserStore();
  const [title, setTile] = useState("Manage Role(s) for this Account")
  const [errMessage, setErrMessage] = useState("");

  const account = selectedUserSponsorAccounts?.account;
  const userData = selectedUserSponsorAccounts?.userData;
  useEffect(() => {
    const selected = roles.find((role) => {
      return role.checked;
    })
    let changed = false;
    roles.forEach((role) => {
      const found = account?.Role?.find(v => {
        return v === role.roleName;
      })
      if ((role.checked && !found) || (!role.checked && found)) {
        changed = true;
      }
    })
    setBtnDisabled(!(selected && changed));
    if (!selected) {
      setErrMessage('Please select a role for this user in order to continue.');
    } else {
      setErrMessage('');
    }
  }, [roles]);
  useEffect(() => {
    const accountRoles = account?.Role;
    if (accountRoles) {
      if (accountRoles.length === 0) {
        setBtnDisabled(true);
        return;
      }
      accountRoles.forEach(r => {
        const found = roles.find(v => v.roleName === r);
        if (found) {
          found.checked = true;
        }
      });
      setRoles([...roles]);
      setBtnDisabled(false);
    }
  }, [selectedUserSponsorAccounts])


  useEffect(() => {
    const roles = account?.Role
    if (roleList.length > 0) {
      const modifiedRole = roleList?.map(ele => {
        ele = {
          ...ele,
          checked: !!roles?.includes(ele.roleName)
        }
        return ele
      })
      setRoles(modifiedRole)
    }
  }, [roleList])

  useEffect(() => {
    get_role_list()
  }, []);

  const onSubmit = () => {
    const selectedRoles = roles.filter(role => role.checked)
    set_selected_roles(selectedRoles);
    set_role_selection_popup_status(false);
    set_selected_role_index(null)
    const resetRoles = roles.map(role => {
      return {...role, checked: false}
    });
    setRoles(resetRoles);
  };

  const onHide = () => {
    roles.forEach(r => {
      r.checked = false;
    });
    setRoles([...roles]);
    set_role_selection_popup_status(false);
  };

  const onRoleSelection = (val, role) => {
    const updatedRole = roles?.map(ele => {
      return ele.roleId === role.roleId ? {...ele, checked: val.target.checked} : ele
    })
    setRoles(updatedRole)
  }

  return (
    <>
      <Modal
        show={roleSelectionPopUpStatus}
        onHide={onHide}>
        <div className="avnet-modal modal-800" id="roleSelection">
          <div className="avnet-modal-inner">
            <button
              type="button"
              className="close py-3"
              data-dismiss="modal"
              onClick={onHide}>
              ×
            </button>
            {ReusableDiv.PopupTitle(title)}
            <div className="modal-body sponsor-account-popup role-selection-popup">
              {(roleListMessage || errMessage) &&
                <AlertContentWithFlag message={roleListMessage || errMessage} type={'danger'} isDisplay={false} isDisplayIcon={true}/>}

              <div className="table-responsive">
                <table className="bs5 table table-bordered">
                  <thead>
                  <tr>
                    <th>ACCOUNT NUMBER</th>
                    <th>ACCOUNT NAME</th>
                    <th>USER NAME</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr key='544'>
                    <td>{account?.AccountNumber}</td>
                    <td>{account?.AccountName} </td>
                    {
                      userData?.userName ?
                        <td>{userData?.userName.trim()} </td> :
                        <td>{userData?.firstName} {userData?.lastName} </td>
                    }
                  </tr>
                  </tbody>
                </table>

               
                
              </div>
              <p className="text-start mt-4 mb-3">
                  <strong> Please select or unselect below to modify assigned user role(s) for this account:</strong>
                </p>
              <div className="bs5 row">
                  {roles?.map((ele, i) => (
                    <div key={i} className="col-6 mb-1 d-flex align-items-center">
                      <input type="checkbox" className="form-check-input font-14 mt-0 me-2"
                             checked={ele.checked}
                             id={ele.roleId}
                             name={ele.roleName} onChange={e => onRoleSelection(e, ele)}/>
                      {'  '}{ele?.roleName} : {ele?.roleDescription}
                    </div>
                  ))}
                </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <button
                type="button"
                className="bs5 btn btn-primary"
                onClick={onSubmit}
                disabled={btnDisabled}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RoleSelection;
